// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ht-0";